// Guest identity — the same server flows before signing in.
//
// A signed-out visitor gets a stable random id (localStorage). Every API request carries it as
// X-Guest-Id; the BFF derives a NAMESPACED userId from it (a hash, so a spoofed real user id can
// never map onto a real account) and propagates that downstream — so ongoings/research run through
// the exact same backend code as a signed-in user, capped by the BFF's guest limits.
//
// On sign-in, auth.service calls ongoing/claim-guest to re-own the guest's ongoings, then rotates
// the id so the next signed-out session starts fresh.

const KEY = 'busy:guestId'

function newId() {
  try {
    return crypto.randomUUID()
  } catch {
    return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}-${Math.random().toString(16).slice(2, 10)}`
  }
}

/** The visitor's stable guest id (created on first use). */
export function getGuestId() {
  try {
    let id = localStorage.getItem(KEY)
    if (!id) {
      id = newId()
      localStorage.setItem(KEY, id)
    }
    return id
  } catch {
    return null
  }
}

/** After the guest's data has been claimed by a real account: start a fresh guest identity. */
export function rotateGuestId() {
  try { localStorage.setItem(KEY, newId()) } catch { /* ignore */ }
}
